import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'talk-to-your-data-brand-group',
  templateUrl: './brand-group.component.html',
  styleUrls: ['./brand-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandGroupComponent {
  constructor(private readonly location: Location) {}
  onBack(): void {
    this.location.back();
  }
}
